let routes = [
  {
    path: '/',
    name: 'app',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: r => require(['views/login/Main'], r)
  }
]

const moduleContext = require.context('./modules', false, /\.js$/)
moduleContext.keys().forEach(path => {
  const module = moduleContext(path).default
  routes = routes.concat(module)
})

export default routes
